<ng-container *transloco="let _t">

<div *ngIf="diagnostics.length>0 else nodiagnostic" class="diagnostics">
<div class="row head">
	<h4 class="col-4"><span>{{ _t('audit-list-span-0') }}</span>
		<cmat-selector
			[values]="filterList"
			[title]="_t('audit-list-title-0')"
			(changeTriggered)="filterDiagnosticsBy($event)"
		></cmat-selector>
	</h4>
	<h4 class="col-2">{{ _t('audit-list-h4-0') }}</h4>
	<h4 class="col-6">{{ _t('audit-list-h4-1') }}</h4>
</div>

<div class="row diagnostic"
	*ngFor="let diagnostic of showedDiagnostics; let i=index" >
	<div class="col-4 audit-name">
		<mat-icon class="md-12" color="accent">youtube_searched_for</mat-icon>
		<p><strong>{{diagnostic.auditName}}</strong></p>
	</div>
	<div class="col-2 date"><em>{{diagnostic.date}}</em></div>
	<div class="col-6 row boxes">

		<!-- ratio 2/12-->
		<div class="col-2" [ngClass]="{
			'ratio-completed': diagnostic.ratio==100,
			'ratio-uncompleted': diagnostic.ratio<100
		}">
			<mat-progress-spinner
				[value]="+diagnostic.ratio"
				[diameter]="20"
				>
			</mat-progress-spinner>
			<small *ngIf="diagnostic.ratio==100">{{diagnostic.ratio}}%</small>
			<span *ngIf="diagnostic.ratio<100">{{diagnostic.ratio}}%</span>
		</div>

		<!-- note : 2/12 -->
		<div class="col-2"
		[ngStyle]="{'background-color': getColor(diagnostic.note), 'color': 'white' }">
			{{diagnostic.note}} / 20
		</div>

    <span class="col-1">&nbsp;</span>

		<!-- boutons : 3 x 2/12 -->

		<!-- modifier ou dupliquer -->
		<button *ngIf="diagnostic.finished==false"
			mat-raised-button class="col-1" color="lessaccent"
			(click)="completeThenEditDiagnostic(diagnostic)" [title]="_t('audit-list-title-1')">
			<mat-icon class="md-12">edit</mat-icon>
		</button>
		<button  *ngIf="diagnostic.finished==true"
			mat-raised-button class="col-1" color="accent"
			(click)="duplicDiagnostic(diagnostic)" [title]="_t('audit-list-title-2')">
			<mat-icon class="md-12">control_point_duplicate</mat-icon>
		</button>

		<!-- Modifier rapport ou accéder au PDF -->
		<button  *ngIf="diagnostic.finished==false"
			mat-raised-button class="col-2" color="secondary"
			(click)="gotoReport(diagnostic)" [title]="_t('audit-list-title-3')">
			<mat-icon class="md-12">description</mat-icon>
		</button>
		<a *ngIf="diagnostic.finished==true && diagnostic.pdfUrl!=''"
			mat-raised-button class="col-2" color="secondary"
			[title]="_t('audit-list-title-4')"
			[href]="diagnostic.pdfUrl" target="_blank">
      <span class="mat-button-wrapper">
        <mat-icon class="md-12">picture_as_pdf</mat-icon>
      </span>
		</a>

		<!-- rien ou management des risques -->
		<!--<span *ngIf="diagnostic.finished==false"
			style="width: 64px;">&nbsp;</span>-->
		<button *ngIf="diagnostic.finished"
			mat-raised-button class="col-1" color="primary"
			[title]="_t('audit-list-title-5')"
			(click)="gotoMDR(diagnostic)">
			<mat-icon class="md-12">account_tree</mat-icon>
		</button>

		<!-- supprimer -->
		<button  *ngIf="!diagnostic.finished"
      mat-raised-button class="col-1" color="warn"
			(click)="deleteDiagnostic(i)" [title]="_t('audit-list-title-6')">
			<mat-icon class="md-12">delete</mat-icon>
		</button>
	</div>
</div>

</div>

<ng-template #nodiagnostic>
	<h3 *ngIf="!isLoading">{{ _t('audit-list-h3-0') }}</h3>
</ng-template>

</ng-container>
